import { render } from "./Wallet.vue?vue&type=template&id=de3cb3f2"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Wallet.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "de3cb3f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('de3cb3f2', __exports__)) {
    api.reload('de3cb3f2', __exports__)
  }
  
  module.hot.accept("./Wallet.vue?vue&type=template&id=de3cb3f2", () => {
    api.rerender('de3cb3f2', render)
  })

}


export default __exports__